module.exports = __webpack_public_path__ + "img/frame (81).bc1f448c.jpg";